import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';

export const FJSliceAiHistoryCommon = createSlice({
    name: 'aiHistoryCommon',
    initialState: {
        isShowAIImageHistoryModal: false, // 是否显示ai图像历史记录模态框
        aiTextToImageHistoryLoadStatus: FJConstant.DEFAULT, // 加载状态
        aiTextToImageHistoryList: [], // ai文本到图像历史记录列表
        aiImageToImageHistoryLoadStatus: FJConstant.DEFAULT, // 加载状态
        aiImageToImageHistoryList: [], // ai图像到图像历史记录列表
    },
    reducers: {
        setSliceAiTextToImageHistoryList: (state, action) => {
            state.aiTextToImageHistoryList = action.payload;
        },
        setSliceAiTextToImageHistoryLoadStatus: (state, action) => {
            state.aiTextToImageHistoryLoadStatus = action.payload;
        },
        setSliceIsShowAIImageHistoryModal: (state, action) => {
            state.isShowAIImageHistoryModal = action.payload;
        },
        setSliceAiImageToImageHistoryLoadStatus: (state, action) => {
            state.aiImageToImageHistoryLoadStatus = action.payload;
        },
        setSliceAiImageToImageHistoryList: (state, action) => {
            state.aiImageToImageHistoryList = action.payload;
        },
    },
});

export const {
    setSliceAiTextToImageHistoryList,
    setSliceAiTextToImageHistoryLoadStatus,
    setSliceIsShowAIImageHistoryModal,
    setSliceAiImageToImageHistoryList,
    setSliceAiImageToImageHistoryLoadStatus,
} = FJSliceAiHistoryCommon.actions;
export default FJSliceAiHistoryCommon.reducer;
